import Providers from 'providers';

import Request from './Request';
import { GlobalStyles } from './RequestApp.styled';

export default function RequestApp() {
  return (
    <Providers>
      <Request />
      <GlobalStyles />
    </Providers>
  );
}
